import { createSelector } from "@reduxjs/toolkit";
import { selectVoucherDiscounts } from "../../vouchersV2/selectors/selectVoucherDiscounts.ts";
import _ from "lodash";

export const selectPiggyVouchersDiscountValue = createSelector([selectVoucherDiscounts], (piggyDiscounts) => {
  return _.chain(piggyDiscounts.discountsPerOrderArticle)
    .reduce((totalValue, item) => totalValue + item.discount, 0)
    .value();
});
